import React, { useContext, useState } from "react";
import styles from "./styles/ChangePwd.module.css";
import Confirmation from "../../Confirmation/Confirmation";
import SHA from "sha.js";
import { UserData } from "../../../Context/DataContext";
import { cancelPWDchange, handlePwdChange } from "../../../Utils/RenewPWD";
import parse from "html-react-parser";
import { SuccessPassChange } from "../My Account/SuccessPassChange";
import { OnProgress } from "../My Account/OnProgress";
import PasswordRequirements from "../../Password Requirements/PasswordRequirements";
import { useEffect } from "react";
import { validatePasswordStrength } from "../../../Utils/passwordRequirements";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import useWindowDimensions from "../../Footer/footer";
function ChangeSelfPwd({ onClose }) {
  const { width } = useWindowDimensions();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.SelfRecovery.ChangeSelfPassword
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.SelfRecovery.ChangeSelfPassword);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [modal, setModal] = useState(null);
  const userData = UserData();

  var private_key = userData.private_key;
  const [data, setData] = useState({
    newpassword1: "",
    newpassword2: "",
  });
  const [error, setError] = useState({
    newpassword1: "",
    newpassword2: "",
  });
  const [req, setReq] = useState({
    length: "",
    digits: "",
    lower: "",
    upper: "",
    special: "",
  });

  const [pwdreq, setpwdreq] = useState();
  const [pwdreqconfirm, setpwdreqConfirm] = useState();
  const [passwordVisibility, setPasswordVisibility] = useState({});
  const handleTogglePassword = (fieldName) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };
  const isPasswordVisible = (fieldName) => {
    return passwordVisibility[fieldName];
  };

  // password popups

  const [passwordIsFocused, setPasswordIsFocused] = useState(false);

  const [hideTimeout, setHideTimeout] = useState(null);

  const handlePasswordFocusIn = () => {
    clearTimeout(hideTimeout); // Clear any existing timeout
    setPasswordIsFocused(true);
    setConfirmPasswordIsFocused(false);
  };

  const handlePasswordFocusOut = () => {
    // Set a delay before hiding the div
    const timeout = setTimeout(() => {
      setPasswordIsFocused(false);
    }, 300); // Adjust the delay time (in milliseconds) as needed
    setHideTimeout(timeout);
  };

  // password confirm popups

  const [confirmPasswordIsFocused, setConfirmPasswordIsFocused] =
    useState(false);

  const [hideConfirmTimeout, setHideConfirmTimeout] = useState(null);

  const handleConfirmPasswordFocusIn = () => {
    clearTimeout(hideConfirmTimeout); // Clear any existing timeout
    setConfirmPasswordIsFocused(true);
    setPasswordIsFocused(false);
  };

  const handleConfirmPasswordFocusOut = () => {
    // Set a delay before hiding the div
    const timeout = setTimeout(() => {
      setConfirmPasswordIsFocused(false);
    }, 300); // Adjust the delay time (in milliseconds) as needed
    setHideConfirmTimeout(timeout);
  };

  useEffect(() => {
    setpwdreq(validatePasswordStrength(data.newpassword1, true));
    setpwdreqConfirm(validatePasswordStrength(data.newpassword2));
  }, [data.newpassword1]);

  const checkPassRequirements = () => {
    setpwdreq(validatePasswordStrength(data.newpassword1, true));
  };
  const checkPassConfirmRequirements = () => {
    setpwdreq(validatePasswordStrength(data.newpassword1, true));
    setpwdreqConfirm(
      validatePasswordStrength(
        data.newpassword2,
        data["newpassword1"] === data["newpassword2"] &&
          data["newpassword2"] !== ""
      )
    );
  };
  useEffect(() => {
    checkPassRequirements();
  }, [data.newpassword1]);

  useEffect(() => {
    checkPassConfirmRequirements();
  }, [data.newpassword2]);

  const cleanErrors = () => {
    setTimeout(() => {
      setError({
        newpassword1: "",
        newpassword2: "",
      });
    }, 5000);
  };

  const uploadState = (state) => {
    setModal(
      <OnProgress
        title={dublicatedcontent?.work_in_progress}
        status={state}
        subtext={content.changeSelfPasswordText1}
      />
    );
  };
  const validatePassword = (password) => {
    const pwd_errors = validatePasswordStrength(
      password,
      data["newpassword1"] === data["newpassword2"] &&
        data["newpassword2"] !== ""
    );
    console.log(pwd_errors);
    setReq(pwd_errors);
  };
  useEffect(() => {
    validatePassword(data.newpassword1);
  }, [data]);
  const handleClick = async () => {
    var error_ = {
      newpassword1: "",
      newpassword2: "",
    };
    var isError = false;
    if (data.newpassword1 !== data.newpassword2) {
      const mes = content.changeSelfPasswordError1;
      error_ = { ...error_, newpassword2: mes };
      isError = true;
    }

    if (
      Object.keys(pwdreq).some(
        (key) => pwdreq[key] === "" && key !== "passmatch"
      )
    ) {
      const mes = content.changeSelfPasswordError2;
      error_ = { ...error_, newpassword1: mes };
      isError = true;
    }

    if (data.newpassword1 === "") {
      error_ = { ...error_, newpassword1: content.changeSelfPasswordError3 };
      isError = true;
    }
    if (data.newpassword2 === "") {
      error_ = { ...error_, newpassword2: content.changeSelfPasswordError4 };
      isError = true;
    }

    if (isError) {
      setError(error_);
      setTimeout(() => {
        cleanErrors();
      }, 5000);
      return;
    }

    setModal(
      <Confirmation
        onClose={() => setModal(null)}
        confirm_button={dublicatedcontent?.confirm}
        cancel_button={dublicatedcontent?.dublicatedText184}
        OnConfirm={() => {
          setModal(
            <OnProgress
              title={dublicatedcontent?.work_in_progress}
              status={content.changeSelfPasswordText2}
              subtext={content.changeSelfPasswordText1}
            />
          );
          const key = `${data.newpassword1}:${data.newpassword1}:${data.newpassword1}:OSTREON`;
          const new_private_key = SHA("sha256").update(key).digest("hex");
          setModal(
            <OnProgress
              title={dublicatedcontent?.work_in_progress}
              status={content.changeSelfPasswordText3}
              subtext={content.changeSelfPasswordText2}
            />
          );
          handlePwdChange(
            private_key,
            new_private_key,
            uploadState,
            userData,
            data.newpassword1,
            undefined,
            dublicatedcontent
          )
            .then((e) => {
              userData.setMyAccount(1);
              setModal(<SuccessPassChange />);
            })
            .catch((e) => {
              uploadState(e.toString());
              setTimeout(() => {
                uploadState(content.changeSelfPasswordText4);
                cancelPWDchange()
                  .then(() => {
                    uploadState(content.changeSelfPasswordText5);
                  })
                  .catch(() => {
                    uploadState(content.changeSelfPasswordText6);
                  });
                setTimeout(() => {
                  setModal();
                }, 3000);
              }, 3000);
            })
            .catch((e) => setModal(null));
        }}
        title={content.changeSelfPasswordText7}
        text={content.changeSelfPasswordText1}
      />
    );
  };
  const handleEnter = (e) => {
    if (e.key === "Enter") {
      handleClick();
    }
  };
  return (
    <div className={styles.main} onKeyDown={handleEnter}>
      <div className={styles.title}>
        {width > 767
          ? parse(content.changeSelfPasswordText8Desktop)
          : content.changeSelfPasswordText8Mobile}
      </div>
      <div className={styles.subtitle}>
        {parse(content.changeSelfPasswordText9)}
      </div>
      <div className={styles.columns}>
        <div className={styles.card}>
          <div className={styles.inputs}>
            <div className={styles.field}>
              <div className={styles.input_title}>
                {content.changeSelfPasswordText10}
              </div>
              <div className={styles.input_wrap}>
                <input
                  onFocus={() => handlePasswordFocusIn()}
                  onBlur={(e) => {
                    handlePasswordFocusOut();
                  }}
                  type={
                    isPasswordVisible("passwordField1") ? "text" : "password"
                  }
                  name="passwordField1"
                  className={`${styles.user_input} ${
                    error.newpassword1 ? styles.input_error : ""
                  }`}
                  onChange={(e) => {
                    setData({ ...data, newpassword1: e.target.value });
                  }}
                  placeholder={content.changeSelfPasswordText11}
                ></input>
                <div
                  onClick={() => handleTogglePassword("passwordField1")}
                  className={styles.password_button}
                >
                  <svg
                    width="18"
                    height="15"
                    viewBox="0 0 18 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                      fill="#B3B3B3"
                    />
                    <path
                      d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                      fill="#B3B3B3"
                    />
                  </svg>
                </div>
              </div>
              {error.newpassword1 ? (
                <div className={styles.error_message}>{error.newpassword1}</div>
              ) : null}
              <div className={styles.password_popups}>
                <PasswordRequirements
                  req={pwdreq}
                  containerStyle={{
                    padding: "10px 25px",
                  }}
                />
              </div>
            </div>
            <div className={styles.field}>
              <div className={styles.input_title}>
                {content.changeSelfPasswordText12}
              </div>
              <div className={styles.input_wrap}>
                <input
                  onFocus={() => handleConfirmPasswordFocusIn()}
                  onBlur={(e) => {
                    handleConfirmPasswordFocusOut();
                  }}
                  type={
                    isPasswordVisible("passwordField2") ? "text" : "password"
                  }
                  name="passwordField2"
                  className={`${styles.user_input} ${
                    error.newpassword2 ? styles.input_error : ""
                  }`}
                  onChange={(e) => {
                    setData({ ...data, newpassword2: e.target.value });
                  }}
                  placeholder={content.changeSelfPasswordText12}
                ></input>
                <div
                  onClick={() => handleTogglePassword("passwordField2")}
                  className={styles.password_button}
                >
                  <svg
                    width="18"
                    height="15"
                    viewBox="0 0 18 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                      fill="#B3B3B3"
                    />
                    <path
                      d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                      fill="#B3B3B3"
                    />
                  </svg>
                </div>
              </div>
              {error.newpassword2 ? (
                <div className={styles.error_message}>{error.newpassword2}</div>
              ) : null}
              <div className={styles.password_confirm_popups}>
                {confirmPasswordIsFocused && (
                  <PasswordRequirements
                    req={pwdreqconfirm}
                    containerStyle={{
                      padding: "10px 25px",
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          <div className={styles.buttons_div}>
            <div
              onClick={() => {
                handleClick();
              }}
              className={styles.save_button}
            >
              {content.changeSelfPasswordText13}
            </div>

            <div className={styles.note}>
              <div className={styles.red_text}>
                {content.changeSelfPasswordText14} -
              </div>
              <div>{content.changeSelfPasswordText15}</div>
              <div>{content.changeSelfPasswordText16}</div>
              <div className={styles.red_text}>
                {content.changeSelfPasswordText17}
              </div>
            </div>
          </div>
        </div>
      </div>
      {<div style={{ zIndex: 3 }}>{modal}</div>}
    </div>
  );
}

export default ChangeSelfPwd;
